// @ts-nocheck
import React, { useEffect, useState } from 'react';
import { useLazyQuery } from '@apollo/client';
import { getProductsFromCollectionHandleInit } from '../../../../../components/shared/query/query.js';
import { allPagesEvent } from '../../../../../components/shared/dataLayer/index';
import './SuccessStyle.scss';
import CopyBtn from '../copyBtn/copyBtn';
import ProductData from '../ProductData/ProductData';
import { connect } from 'react-redux';
import { Link } from 'gatsby';
import moment from 'moment-timezone';
const mapStateToProps = (state) => ({
  currency: state.currency,
  currencyTable: state.currencyTable,
});

function QuizSuccess(props) {
  let Selectday = moment.tz(new Date(), 'Europe/Berlin').format('D');
  //let Selectday = '19';
  const [getProductsFromCollectionHandleInitQuery, { data: getProductsFromCollectionData }] = useLazyQuery(
    getProductsFromCollectionHandleInit,
  );
  const [searchInput, setSearchInput] = useState('');
  const [emptySearchData, setEmptySearchData] = useState();
  const [productId, setProductId] = useState('');
  const [colorSwatchElementState, setColorSwatchElementState] = useState();
  useEffect(() => {
    if (getProductsFromCollectionData && getProductsFromCollectionData.collectionByHandle) {
      let tempProductEdges = JSON.parse(
        JSON.stringify(getProductsFromCollectionData.collectionByHandle.products.edges),
      );

      let pushingData = [];

      for (let singleLoop of tempProductEdges) {
        pushingData.push(singleLoop.node);
      }

      setEmptySearchData(pushingData);
    }
  }, [getProductsFromCollectionData]);

  let ColorHandle = (data) => {
    let colors = [];
    for (const singleTag of data) {
      if (singleTag.includes('handle_')) {
        let color = singleTag.replace('handle_', '');
        const spliceIndex = color.indexOf('+');
        color = color.slice(0, spliceIndex);
        colors.push({
          color,
        });
      }
    }
    return colors.length;
  };

  useEffect(() => {
    let savedLocation = window.location.pathname.replace('/de/', '/');
    savedLocation = savedLocation.replace('/collections/', '');
    while (savedLocation.includes('%20')) {
      savedLocation = savedLocation.replace('%20', ' ');
    }
    if (props.searchInput !== savedLocation) {
      setSearchInput(decodeURIComponent(savedLocation));
      window.scrollTo(0, 0);
    }

    getProductsFromCollectionHandleInitQuery({
      variables: {
        currencyCode: props.currency.currencyCode,
        handle: 'quiz-produkte',
        first: 3,
      },
    });
  }, [typeof window !== `undefined` && window.location.pathname, props.location]);

  useEffect(() => {
    allPagesEvent();
  }, [typeof window !== `undefined` && window && window.dataLayer]);

  const [handle, setHandle] = useState('');

  let handleChange = (item) => {
    if (item) {
      setHandle(item);
    }
  };

  const [addToCart, setAddToCard] = useState(false);
  let AddToCard = (data) => {
    if (data) {
      setAddToCard(true);
    }
  };

  const [copySuccess, setCopySuccess] = useState('');

  let copyToClipBoard = () => {
    setCopySuccess('Kopiert!');
  };

  const [codeList, setCodeList] = useState({
    code: [
      { day: '5', code: '8ER3HMB1X9F0QUIZ' },
      { day: '15', code: '8ER3HMB1X9F0QUIZ' },
      { day: '19', code: '8ER3HMB1X9F0QUIZ' },
      { day: '24', code: '8ER3HMB1X9F0QUIZ' },
    ],
  });

  let backHandle = (handle) => {
    setHandle('');
  };

  return (
    <div className="quiz-product-container">
      {handle === '' ? (
        <>
          <div className="quiz-product-title">
            {/* <p>YOU WON </p> */}
            <div className="quiz-su-small">
              Ab einem Bestellwert von 150 EUR verschenken wir Ihnen eines der folgenden Produkte!
            </div>
          </div>
          <div className="quiz-product-img">
            {emptySearchData &&
              // @ts-ignore
              emptySearchData.map((item, i) => (
                <div
                  key={i}
                  // @ts-ignore
                  onClick={() => handleChange(item.handle)}
                >
                  <>
                    <img
                      alt={item.images.edges[0].node.altText}
                      style={{ width: '100%' }}
                      srcSet={
                        `${item.images.edges[0].node.originalSrc.replace('.jpg', '_260x.jpg')} 260w,` +
                        `${item.images.edges[0].node.originalSrc.replace('.jpg', '_390x.jpg')} 390w,` +
                        `${item.images.edges[0].node.originalSrc.replace('.jpg', '_468x.jpg')} 468w,` +
                        `${item.images.edges[0].node.originalSrc.replace('.jpg', '_560x.jpg')} 560w,` +
                        `${item.images.edges[0].node.originalSrc.replace('.jpg', '_640x.jpg')} 640w,` +
                        `${item.images.edges[0].node.originalSrc.replace('.jpg', '_750x.jpg')} 750w,` +
                        `${item.images.edges[0].node.originalSrc.replace('.jpg', '_828x.jpg')} 828w,` +
                        `${item.images.edges[0].node.originalSrc.replace('.jpg', '_1080x.jpg')} 1080w,` +
                        `${item.images.edges[0].node.originalSrc.replace('.jpg', '_1280x.jpg')} 1280w,`
                      }
                    />
                    <div className="product-detail">
                      <div className="pr-title">{item.title}</div>
                      <div>
                        <p>+ {ColorHandle(item.tags)} farben</p>{' '}
                      </div>
                      <div className="pr-tt"> € {item.variants.edges[0].node.priceV2.amount}</div>
                    </div>
                  </>
                </div>
              ))}
          </div>
        </>
      ) : addToCart === false ? (
        <ProductData handle={handle} AddToCard={AddToCard} backHandle={backHandle} />
      ) : (
        <>
          <div className="shipp-container">
            <div className="shipp-title">
              <p> Herzlichen Glückwunsch! </p>
              <span> Ab einem Bestellwert von 150 EUR erhalten Sie das von Ihnen ausgewählte Produkt.</span>
            </div>
            <CopyBtn
              copyToClipBoard={copyToClipBoard}
              copySuccess={copySuccess}
              codeList={codeList}
              Selectday={Selectday}
            />
            <Link to="https://www.gobicashmere.com/de/collections/holiday" className="shipp-btn">
              Weiter zum Shop
            </Link>
            <div style={{ marginBottom: '47px' }}></div>
          </div>
        </>
      )}
    </div>
  );
}

export default connect(mapStateToProps)(QuizSuccess);
